export default "__VITE_ASSET__71313f8d__"